<template>
  <div class="mt-4">
    <h4 class="card-title mt-0 mb-4">
      {{ i18n.global.t('pages.monthlyReport.preCreate') }}
    </h4>
    <div class="pb-3 pt-2">
      <v-row class="mb-1">
        <MonthlyReportPreCreateStatus
          :operation-office-id="props.operationOfficeId"
          :year-month="props.yearMonth"
        />
        <MonthlyReportPreCreateButtonArea
          :operation-office-id="props.operationOfficeId"
          :year-month="props.yearMonth"
          :show-flash="props.showFlash"
        />
      </v-row>
    </div>
  </div>
</template>

<script setup lang="ts">
import MonthlyReportPreCreateStatus from "@/components/MonthyReportParts/MonthlyReportPreCreateStatus.vue";
import MonthlyReportPreCreateButtonArea from "@/components/MonthyReportParts/MonthlyReportPreCreateButtonArea.vue";
import i18n from '@/lang/i18n';

const props = defineProps<{
  operationOfficeId?: number | null;
  yearMonth?: string | null;
  showFlash?: (message: string, type: string, fadeout: boolean) => void;
}>();

</script>
